import { getUnpaidBills, getAllPlanDetails } from "../api/api";
import { SequenceManagerAction } from './SequenceManagerAction';

const UnpaidBillsAction = {
    FETCH_UNPAID_BILLS_SUCCESS: "FETCH_UNPAID_BILLS_SUCCESS",
    FETCH_UNPAID_BILLS_FAILURE: "FETCH_UNPAID_BILLS_FAILURE",
    GET_PLAN_DETAILS_SUCCESS: "GET_PLAN_DETAILS_SUCCESS",
    GET_PLAN_DETAILS_FAILURE: "GET_PLAN_DETAILS_FAILURE",
    UNPAID_BILLS_ACCEPTED: "UNPAID_BILLS_ACCEPTED"
} as const;

const getCustomerUnpaidBills = (personId: any, newStack:any) => {
    return function (dispatch: any) {
        getUnpaidBills(personId, newStack).then((response) => {
            dispatch({type: UnpaidBillsAction.FETCH_UNPAID_BILLS_SUCCESS, payload:response});
        })
        .catch((error) => {
            //Display error
            dispatch({type: SequenceManagerAction.GENERIC_ERROR, payload:error});
        })
    }
}

const getAllUnpaidPlanDetails = (externalIds:any) => {
    return function (dispatch: any) {
        getAllPlanDetails(externalIds).then((response) => {
            dispatch({type: UnpaidBillsAction.GET_PLAN_DETAILS_SUCCESS, payload:response.data});
        })
        .catch((error) => {
            //Display error
            dispatch({type: SequenceManagerAction.GENERIC_ERROR, payload:error});
        })
    }
}

const acceptUnpaidBills = ( unpaidBillResponse: any, offerContainerId: any) => {
    return function (dispatch: any) {
        dispatch({ type: UnpaidBillsAction.UNPAID_BILLS_ACCEPTED, payload: { unpaidBillResponse: unpaidBillResponse, offerContainerId: offerContainerId }});
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['UnpaidBills']});
    }
}

export { UnpaidBillsAction, getCustomerUnpaidBills, getAllUnpaidPlanDetails, acceptUnpaidBills };
